import React from 'react'

import './TopQuestionsFilter.scss'

export const TopQuestionsFilter: React.FC = () => {


  return <div className={'topQuestionFilter'}>
    {/*<TopQuestionsNameFilterInput />*/}
    {/*<TopQuestionsTypeSelect />*/}
  </div>
}
